// Translations IT/EN
import { premiumIT, premiumEN } from "./premium";

export const translations = {
  it: {
    ...premiumIT,
    nav: {
      services: "Servizi",
      packages: "Pacchetti",
      about: "Chi siamo",
      contact: "Contatti",
      cta: "Prenota una consulenza",
    },
    hero: {
      eyebrow: "Consulenza IT Premium · Italia",
      title: "Soluzioni informatiche per accelerare la crescita del tuo business",
      subtitle: "Consulenza IT, digitalizzazione e supporto tecnologico per professionisti e aziende che vogliono lavorare meglio e crescere più velocemente.",
      ctaPrimary: "Prenota una consulenza",
      ctaSecondary: "Scopri i pacchetti",
      trustBadge: "Soluzioni progettate per PMI, professionisti ed e-commerce",
    },
    services: {
      eyebrow: "Servizi",
      title: "Tutto ciò che ti serve per innovare",
      subtitle: "Quattro aree di intervento per portare la tua azienda al livello successivo.",
      items: [
        { title: "Consulenza Informatica", desc: "Analisi delle esigenze aziendali e individuazione delle migliori soluzioni tecnologiche." },
        { title: "Digitalizzazione dei Processi", desc: "Ottimizzazione dei flussi di lavoro e automazione delle attività ripetitive." },
        { title: "Supporto Tecnologico", desc: "Assistenza e supporto su software, strumenti digitali e infrastrutture." },
        { title: "Strategia Digitale", desc: "Pianificazione e miglioramento dell'organizzazione tecnologica dell'azienda." },
      ],
    },
    pricing: {
      eyebrow: "Pacchetti",
      title: "Scegli il piano giusto per te",
      subtitle: "Prezzi trasparenti. Nessuna sorpresa. Cancellazione semplice.",
      perPackage: "una tantum",
      mostPopular: "Più richiesto",
      buyNow: "Acquista ora",
      contactUs: "Contattaci",
      packages: [
        {
          id: "starter",
          code: "ZDC-STR-01",
          name: "Starter",
          price: 99,
          tagline: "Ideale per professionisti e piccoli progetti.",
          features: ["30 minuti di consulenza", "Analisi iniziale", "Report sintetico"],
          cta: "Acquista ora",
        },
        {
          id: "business",
          code: "ZDC-BUS-02",
          name: "Business",
          price: 299,
          tagline: "Il più richiesto.",
          features: ["1 ora di consulenza", "Analisi dettagliata", "Piano operativo", "Supporto via email"],
          highlight: true,
          cta: "Acquista ora",
        },
        {
          id: "professional",
          code: "ZDC-PRO-03",
          name: "Professional",
          price: 799,
          tagline: "Per aziende in crescita.",
          features: ["3 ore di consulenza", "Analisi approfondita", "Ottimizzazione processi", "Supporto prioritario"],
          cta: "Acquista ora",
        },
        {
          id: "enterprise",
          code: "ZDC-ENT-04",
          name: "Enterprise",
          price: 1999,
          tagline: "Per aziende strutturate.",
          features: ["Consulenza avanzata", "Studio completo del progetto", "Strategie personalizzate", "Assistenza dedicata"],
          cta: "Acquista ora",
        },
        {
          id: "premium",
          code: "ZDC-PRM-05",
          name: "Premium Partnership",
          price: 4999,
          tagline: "Servizio ad alto valore.",
          features: ["Affiancamento strategico", "Supporto continuativo", "Analisi e pianificazione personalizzate", "Priorità assoluta"],
          cta: "Contattaci",
          contactOnly: true,
        },
      ],
    },
    configurator: {
      eyebrow: "Su misura",
      title: "Hai esigenze specifiche?",
      subtitle: "Configura una consulenza su misura e ricevi un preventivo personalizzato.",
      hours: "Numero di ore",
      complexity: "Livello di complessità",
      complexityOptions: { base: "Base", intermedio: "Intermedio", avanzato: "Avanzato" },
      urgency: "Urgenza del progetto",
      urgencyOptions: { standard: "Standard (2-4 settimane)", alta: "Alta (1-2 settimane)", critica: "Critica (entro 5 giorni)" },
      description: "Descrizione delle esigenze",
      descriptionPlaceholder: "Raccontaci il tuo progetto, gli obiettivi e le sfide attuali...",
      budget: "Budget indicativo",
      budgetPlaceholder: "Es: 2.000 - 5.000 €",
      name: "Nome e cognome",
      email: "Email",
      company: "Azienda (opzionale)",
      priceLabel: "Prezzo personalizzato su richiesta",
      submit: "Richiedi preventivo",
      success: "Richiesta inviata! Ti contatteremo entro 24 ore.",
    },
    testimonials: {
      eyebrow: "Testimonianze",
      title: "I clienti che hanno scelto Zuin Digital",
      items: [
        {
          name: "Marco Bianchi",
          role: "CEO, Studio Bianchi Srl",
          text: "Fabrizio ci ha aiutato a digitalizzare l'intero ciclo di vendita. Risultati visibili in 6 settimane.",
        },
        {
          name: "Giulia Romano",
          role: "Founder, Atelier Romano",
          text: "Consulenza chiara, concreta e con risultati misurabili. Il pacchetto Business è stato perfetto per noi.",
        },
        {
          name: "Alessandro Conti",
          role: "Direttore Operativo, Conti & Partners",
          text: "Professionalità altissima. Ha trasformato il nostro modo di lavorare con strumenti digitali su misura.",
        },
      ],
    },
    about: {
      eyebrow: "Chi siamo",
      title: "Chi è Fabrizio Zuin",
      text: "Fabrizio Zuin è un consulente informatico specializzato nell'aiutare aziende e professionisti a sfruttare al meglio la tecnologia attraverso soluzioni pratiche, efficienti e orientate ai risultati.",
      points: [
        "10+ anni di esperienza in consulenza IT",
        "Partner di PMI, e-commerce e professionisti",
        "Approccio orientato al ROI e ai risultati",
      ],
    },
    finalCta: {
      title: "Pronto a migliorare la tua infrastruttura digitale?",
      subtitle: "Parla con Fabrizio e scopri come la tecnologia può lavorare al servizio dei tuoi obiettivi.",
      cta: "Prenota una consulenza",
    },
    booking: {
      title: "Prenota una consulenza",
      subtitle: "Lascia i tuoi dati: ti ricontatteremo entro 24 ore.",
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono (opzionale)",
      company: "Azienda (opzionale)",
      message: "Come possiamo aiutarti?",
      submit: "Invia richiesta",
      success: "Grazie! Ti ricontatteremo entro 24 ore.",
    },
    checkout: {
      title: "Completa l'ordine",
      summary: "Riepilogo ordine",
      customerData: "Dati cliente",
      paymentMethod: "Metodo di pagamento",
      fullName: "Nome e cognome",
      email: "Email",
      company: "Azienda (opzionale)",
      vat: "Partita IVA (opzionale)",
      nexi: "Carta di credito · Nexi",
      viva: "Carta · Apple Pay · Google Pay",
      vivaSub: "via Viva.com",
      nexiSub: "Pagamento sicuro 3DS",
      trustSsl: "Connessione SSL sicura",
      trustPayments: "Pagamenti protetti",
      trustPrivacy: "Privacy garantita",
      total: "Totale",
      submit: "Completa l'acquisto",
      processing: "Reindirizzamento in corso...",
      cancel: "Annulla",
      configureWarning: "Modalità demo: le credenziali del gateway non sono configurate. La richiesta verrà salvata e ti contatteremo per completare il pagamento.",
    },
    footer: {
      tagline: "Soluzioni informatiche per accelerare la crescita del tuo business.",
      owner: "Titolare",
      vat: "P. IVA",
      email: "Email",
      rights: "Tutti i diritti riservati.",
      links: { services: "Servizi", packages: "Pacchetti", about: "Chi siamo", contact: "Contatti" },
    },
  },
  en: {
    ...premiumEN,
    nav: {
      services: "Services",
      packages: "Packages",
      about: "About",
      contact: "Contact",
      cta: "Book a consultation",
    },
    hero: {
      eyebrow: "Premium IT Consulting · Italy",
      title: "IT solutions to accelerate your business growth",
      subtitle: "IT consulting, digitalization, and tech support for professionals and companies that want to work smarter and grow faster.",
      ctaPrimary: "Book a consultation",
      ctaSecondary: "Discover packages",
      trustBadge: "Designed for SMBs, professionals, and e-commerce",
    },
    services: {
      eyebrow: "Services",
      title: "Everything you need to innovate",
      subtitle: "Four areas to take your business to the next level.",
      items: [
        { title: "IT Consulting", desc: "Business needs analysis and best-fit technology solutions." },
        { title: "Process Digitalization", desc: "Workflow optimization and automation of repetitive tasks." },
        { title: "Tech Support", desc: "Assistance for software, digital tools, and infrastructures." },
        { title: "Digital Strategy", desc: "Planning and improving your company's technology organization." },
      ],
    },
    pricing: {
      eyebrow: "Packages",
      title: "Choose the right plan for you",
      subtitle: "Transparent pricing. No surprises. Easy to cancel.",
      perPackage: "one-time",
      mostPopular: "Most popular",
      buyNow: "Buy now",
      contactUs: "Contact us",
      packages: [
        { id: "starter", code: "ZDC-STR-01", name: "Starter", price: 99, tagline: "Great for freelancers and small projects.", features: ["30 minutes of consulting", "Initial analysis", "Summary report"], cta: "Buy now" },
        { id: "business", code: "ZDC-BUS-02", name: "Business", price: 299, tagline: "The most requested.", features: ["1 hour of consulting", "Detailed analysis", "Operational plan", "Email support"], highlight: true, cta: "Buy now" },
        { id: "professional", code: "ZDC-PRO-03", name: "Professional", price: 799, tagline: "For growing companies.", features: ["3 hours of consulting", "In-depth analysis", "Process optimization", "Priority support"], cta: "Buy now" },
        { id: "enterprise", code: "ZDC-ENT-04", name: "Enterprise", price: 1999, tagline: "For structured companies.", features: ["Advanced consulting", "Full project study", "Tailored strategies", "Dedicated support"], cta: "Buy now" },
        { id: "premium", code: "ZDC-PRM-05", name: "Premium Partnership", price: 4999, tagline: "High-value service.", features: ["Strategic partnership", "Continuous support", "Personalized analysis and planning", "Absolute priority"], cta: "Contact us", contactOnly: true },
      ],
    },
    configurator: {
      eyebrow: "Tailored",
      title: "Have specific needs?",
      subtitle: "Configure a tailored consulting plan and receive a personalized quote.",
      hours: "Number of hours",
      complexity: "Complexity level",
      complexityOptions: { base: "Basic", intermedio: "Intermediate", avanzato: "Advanced" },
      urgency: "Project urgency",
      urgencyOptions: { standard: "Standard (2-4 weeks)", alta: "High (1-2 weeks)", critica: "Critical (within 5 days)" },
      description: "Describe your needs",
      descriptionPlaceholder: "Tell us about your project, goals, and current challenges...",
      budget: "Indicative budget",
      budgetPlaceholder: "e.g. €2,000 - €5,000",
      name: "Full name",
      email: "Email",
      company: "Company (optional)",
      priceLabel: "Custom price on request",
      submit: "Request a quote",
      success: "Request sent! We'll contact you within 24h.",
    },
    testimonials: {
      eyebrow: "Testimonials",
      title: "Clients who chose Zuin Digital",
      items: [
        { name: "Marco Bianchi", role: "CEO, Studio Bianchi Srl", text: "Fabrizio helped us digitize our entire sales cycle. Visible results in 6 weeks." },
        { name: "Giulia Romano", role: "Founder, Atelier Romano", text: "Clear, concrete consulting with measurable results. The Business package was perfect for us." },
        { name: "Alessandro Conti", role: "Operations Director, Conti & Partners", text: "Top-class professionalism. Transformed our way of working with bespoke digital tools." },
      ],
    },
    about: {
      eyebrow: "About",
      title: "Meet Fabrizio Zuin",
      text: "Fabrizio Zuin is an IT consultant specialized in helping companies and professionals leverage technology with practical, efficient, results-driven solutions.",
      points: ["10+ years of IT consulting experience", "Partner of SMBs, e-commerce, and professionals", "ROI- and results-focused approach"],
    },
    finalCta: {
      title: "Ready to upgrade your digital infrastructure?",
      subtitle: "Talk to Fabrizio and discover how technology can serve your goals.",
      cta: "Book a consultation",
    },
    booking: {
      title: "Book a consultation",
      subtitle: "Leave your details: we'll get back within 24 hours.",
      name: "Full name",
      email: "Email",
      phone: "Phone (optional)",
      company: "Company (optional)",
      message: "How can we help?",
      submit: "Send request",
      success: "Thanks! We'll contact you within 24 hours.",
    },
    checkout: {
      title: "Complete your order",
      summary: "Order summary",
      customerData: "Customer details",
      paymentMethod: "Payment method",
      fullName: "Full name",
      email: "Email",
      company: "Company (optional)",
      vat: "VAT number (optional)",
      nexi: "Credit card · Nexi",
      viva: "Card · Apple Pay · Google Pay",
      vivaSub: "via Viva.com",
      nexiSub: "Secure 3DS payment",
      trustSsl: "Secure SSL connection",
      trustPayments: "Protected payments",
      trustPrivacy: "Privacy guaranteed",
      total: "Total",
      submit: "Complete purchase",
      processing: "Redirecting...",
      cancel: "Cancel",
      configureWarning: "Demo mode: gateway credentials are not configured. Your request will be saved and we'll contact you to complete payment.",
    },
    footer: {
      tagline: "IT solutions to accelerate your business growth.",
      owner: "Owner",
      vat: "VAT",
      email: "Email",
      rights: "All rights reserved.",
      links: { services: "Services", packages: "Packages", about: "About", contact: "Contact" },
    },
  },
};
